import * as PIXI from 'pixi.js';
import GameConfig from '../../game/GameConfig';
import GameUtils from '../../game/GameUtils';
import {MapState} from '../../common/map/MapState';
import {buildingTintForPlayerIndex} from '../player-colors';
import MapRenderer from './MapRenderer';

import Sprite = PIXI.Sprite;

export class SpawnRenderer {
    private spawnSprites: Sprite[] = [];
    private map: MapState;

    public redraw(map: MapState): void {
        this.map = map;
        this.clear();
        this.renderSpawns();
    }

    public clear(): void {
        this.spawnSprites.forEach(sprite => {
            MapRenderer.castleContainer.removeChild(sprite);
        });
        this.spawnSprites = [];
    }

    public renderSpawns(): void {
        this.map.spawns.forEach(spawn => {
            const x = spawn.x * GameConfig.tileSize;
            const y = spawn.y * GameConfig.tileSize;
            const texture = GameUtils.spriteTexture('castle');
            const sprite = new Sprite(texture);
            sprite.position.set(x, y);
            const color =
                this.map.heldBy[spawn.y][spawn.x] === -1
                    ? spawn.owner
                    : this.map.heldBy[spawn.y][spawn.x];
            sprite.tint = buildingTintForPlayerIndex(color);
            this.spawnSprites.push(sprite);
            MapRenderer.castleContainer.addChild(sprite);
        });
    }
}

export const spawnRenderer = new SpawnRenderer();



// WEBPACK FOOTER //
// ./src/Pixi/map/SpawnRenderer.ts